"use server";

import { extractDomain } from "../utils/domain";
import { getPageBySlug } from "../services/pageService";

export async function getPageAction(slug: string) {
  try {
    const domain = await extractDomain();
    const response = await getPageBySlug(slug, domain);
    return response;
  } catch (error) {
    console.error(`[getPageAction] Error fetching page action for ${slug}:`, error);
    return null;
  }
}
